import { render, staticRenderFns } from "./order_groups2.vue?vue&type=template&id=42620490&scoped=true&"
import script from "./order_groups2.vue?vue&type=script&lang=js&"
export * from "./order_groups2.vue?vue&type=script&lang=js&"
import style0 from "./order_groups2.vue?vue&type=style&index=0&id=42620490&prod&scoped=true&lang=css&"
import style1 from "./compact_order_toggle2.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42620490",
  null
  
)

export default component.exports